import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';

import { OperationsService } from '../../../common/services/operations/operations.service';
import { Wizard } from '../../../shared/wizard-v2/wizard-core/wizard/wizard';
import { WizardComponent } from '../../../shared/wizard-v2/wizard-core/wizard/wizard.component';
import { BiometricsRegistrationErrorPopUpComponent } from '../biometrics-registration-error-pop-up/biometrics-registration-error.pop-up.component';
import { BiometricsRegistrationPopUpComponent } from '../biometrics-registration-pop-up/biometrics-registration.pop-up.component';
import { BiometricsRegistrationSuccessPopUpComponent } from '../biometrics-registration-success-pop-up/biometrics-registration-success.pop-up.component';

import { BiometricsRegistrationWizardService } from './biometrics-registration-wizard.service';
import { AdditionalCondition } from './models/models';
import { BiometricsRegistrationFirstStep } from './steps/biometrics-registration-first-step';
import { BiometricsRegistrationSecondStep } from './steps/biometrics-registration-second-step';
import { BiometricsRegistrationThirdStep } from './steps/biometrics-registration-third-step';

@Component({
    selector: 'app-biometrics-registration-wizard',
    templateUrl: './biometrics-registration-wizard.component.html',
    styleUrls: ['./biometrics-registration-wizard.component.less'],
    standalone: false,
})
export class BiometricsRegistrationWizardComponent implements WizardComponent, OnDestroy {

	@Input()
	public biometricsRegistrationPopUpComponent: BiometricsRegistrationPopUpComponent;

	@Input()
	public biometricsRegistrationErrorPopUpComponent: BiometricsRegistrationErrorPopUpComponent;

	@Input()
	public biometricsRegistrationSuccessPopUpComponent: BiometricsRegistrationSuccessPopUpComponent;

	public wizard: Wizard;

	public ngUnsubscribe$$: Subject<void> = new Subject<void>();

	public isOpenConditions: boolean = false;

	constructor(
		public activatedRoute: ActivatedRoute,
		public biometricsRegistrationWizardService: BiometricsRegistrationWizardService,
		public operationsService: OperationsService,
		public changeDetectorRef: ChangeDetectorRef,
	) {
		this.initWizard();
	}

	public ngOnDestroy(): void {
		this.ngUnsubscribe$$.next();
	}

	public initWizard() {
		this.wizard = new Wizard('Регистрация');
		this.wizard.progressBarSteps = [
			{title: 'Регистрация'},
			{title: 'Условия'},
			{title: 'Код подтверждения'},
		];
		const step1: BiometricsRegistrationFirstStep = new BiometricsRegistrationFirstStep(this, this.wizard);
		const step2: BiometricsRegistrationSecondStep = new BiometricsRegistrationSecondStep(this, this.wizard);
		const step3: BiometricsRegistrationThirdStep = new BiometricsRegistrationThirdStep(this, this.wizard);

		this.wizard.addStep(step1);
		this.wizard.addStep(step2);
		this.wizard.addStep(step3);

		this.wizard.start();
	}

	public getConditions(): Array<AdditionalCondition> {
		return (this.wizard?.steps[0] as BiometricsRegistrationFirstStep)?.getConditions();
	}
	public conditionsClickOnTitle(): void {
		this.isOpenConditions = false;
	}
}
